import { Action, SIGNED_OUT_USER } from "../../actions";
import { IApplicationState, ITPPState, ISelectedTPPState, IGenerateApiKeyState, IGenerateSecretState, IProductsState } from '../ApiManagementSandboxReducers/ApiManagementSandboxReducers';
import { combineReducers, Reducer } from 'redux';
import { GenericState, initialGenericState } from "../../reduxTypes";
import { IGoLiveResponse } from "../../../API/ApiManagementTypes";

export const GET_PRODUCTION_PRODUCT = 'GET_PRODUCTION_PRODUCT'

//function getProductReducer ()

export const GET_PRODUCTION_APPLICATION = 'GET_PRODUCTION_APPLICATION';
export const FLUSH_STATE = 'FLUSH_STATE';
export const FLUSH_RESULTS = 'FLUSH_RESULTS';
export const TPP_PROD_ERROR = 'TPP_PROD_ERROR';

export interface ICreateProductionTPPState extends GenericState {
    errors: any
}

const initialCreateTPPState: ICreateProductionTPPState = {
    loading: false,
    error: false,
    data: null,
    errors: null
}

const initialApplicationState: IApplicationState = {
    loading: false,
    error: false,
    data: null
}

function getApplicationReducer(state = initialApplicationState, action: Action): IApplicationState {
    switch (action.type) {
        case `${GET_PRODUCTION_APPLICATION}_PENDING`:
            return { ...state, loading: true, error: false, data: null };
        case `${GET_PRODUCTION_APPLICATION}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${GET_PRODUCTION_APPLICATION}_REJECTED`:
            return { ...state, loading: false, error: true };
        case SIGNED_OUT_USER:
            return initialApplicationState
        default: return state;
    }
}

export const UPDATE_PROD_APPLICATION = 'UPDATE_PROD_APPLICATION'

function updateApplicationReducer(state = initialApplicationState, action: Action): IApplicationState {
    switch (action.type) {
        case `${UPDATE_PROD_APPLICATION}_PENDING`:
            return { ...state, loading: true, error: false, data: null };
        case `${UPDATE_PROD_APPLICATION}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${UPDATE_PROD_APPLICATION}_REJECTED`:
            return { ...state, loading: false, error: true };
        case FLUSH_RESULTS:
            return initialApplicationState
        case SIGNED_OUT_USER:
            return initialApplicationState
        default: return state;
    }
}


const initialTPPState: ITPPState = {
    loading: false,
    error: false,
    data: null,
    verified: true
}

export const GET_PRODUCTION_TPP = 'GET_PRODUCTION_TPP'

function getTPPReducer(state = initialTPPState, action: Action): ITPPState {
    switch (action.type) {
        case `${GET_PRODUCTION_TPP}_PENDING`:
            return { ...state, loading: true, error: false, data: null };
        case `${GET_PRODUCTION_TPP}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${GET_PRODUCTION_TPP}_REJECTED`:
            return { ...state, loading: false, error: true };
        case SIGNED_OUT_USER:
            return initialTPPState
        default: return state;
    }
}

export const UPDATE_PROD_TPP = 'UPDATE_PROD_TPP'

function updateTPPReducer(state = initialCreateTPPState, action: Action): ICreateProductionTPPState {
    switch (action.type) {
        case `${UPDATE_PROD_TPP}_PENDING`:
            return { ...state, loading: true, error: false, data: null };
        case `${UPDATE_PROD_TPP}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${UPDATE_PROD_TPP}_REJECTED`:
            return { ...state };
        case TPP_PROD_ERROR:
            return { ...state, loading: false, error: true, data: action.payload }
        case SIGNED_OUT_USER:
            return initialCreateTPPState;
        case FLUSH_STATE:
            return initialCreateTPPState
        case FLUSH_RESULTS:
            return initialCreateTPPState;
        default: return { ...state };
    }
}

export const GET_SELECTED_PRODUCTION_TPP = 'GET_SELECTED_PRODUCTION_TPP'
const initialSelectedTPPState: ISelectedTPPState = {
    loading: false,
    error: false,
    data: null,
    verified: true
}

function getSelectedTPPReducer(state = initialSelectedTPPState, action: Action): ISelectedTPPState {
    switch (action.type) {
        case `${GET_SELECTED_PRODUCTION_TPP}_PENDING`:
            return { ...state, loading: true, error: false, data: null };
        case `${GET_SELECTED_PRODUCTION_TPP}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${GET_SELECTED_PRODUCTION_TPP}_REJECTED`:
            return { ...state, loading: false, error: true };
        case SIGNED_OUT_USER:
            return initialSelectedTPPState;
        default: return state;
    }
}


const initialGenerateApiKeyState: IGenerateApiKeyState = initialGenericState;

export const GENERATE_PRODUCTION_API_KEY = 'GENERATE_PRODUCTION_API_KEY';
export const FLUSH_PRODUCTION_API_KEY = 'FLUSH_PRODUCTION_API_KEY';

function generateApiKeyReducer(state = initialGenerateApiKeyState, action: Action) {
    switch (action.type) {
        case `${GENERATE_PRODUCTION_API_KEY}_PENDING`:
            return { ...state, loading: true, error: false };
        case `${GENERATE_PRODUCTION_API_KEY}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${GENERATE_PRODUCTION_API_KEY}_REJECTED`:
            return { ...state, loading: false, error: true };
        case FLUSH_PRODUCTION_API_KEY:
            return initialGenerateApiKeyState;
        default: return state;
    }
}


const initialGenerateSecretState: IGenerateSecretState = initialGenericState

export const GENERATE_PRODUCTION_SECRET = 'GENERATE_PRODUCTION_SECRET';
export const FLUSH_PRODUCTION_SECRET = 'FLUSH_PRODUCTION_SECRET';

function generateSecretReducer(state = initialGenerateSecretState, action: Action) {
    switch (action.type) {
        case `${GENERATE_PRODUCTION_SECRET}_PENDING`:
            return { ...state, loading: true, error: false };
        case `${GENERATE_PRODUCTION_SECRET}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${GENERATE_PRODUCTION_SECRET}_REJECTED`:
            return { ...state, loading: false, error: true };
        case FLUSH_PRODUCTION_SECRET:
            return initialGenerateSecretState;
        case FLUSH_RESULTS:
            return initialGenerateSecretState;
        default: return state;
    }

}

export const VALIDATE_PROD_TPP = 'VALIDATE_PROD_TPP';
export const TPP_PROD_VALIDATION_ERROR = 'TPP_PROD_VALIDATION_ERROR';
export const CLEAR_VALIDATION_TPP = 'CLEAR_VALIDATION_TPP';

interface IValidateProdTPPSTate extends GenericState { }

function validateTPPReducer(state: IValidateProdTPPSTate = initialCreateTPPState, action: Action): IValidateProdTPPSTate {
    switch (action.type) {
        case `${VALIDATE_PROD_TPP}_PENDING`:
            return { ...state, loading: true, error: false, }
        case `${VALIDATE_PROD_TPP}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload }
        case `${VALIDATE_PROD_TPP}_REJECTED`:
            return { ...state, loading: false }
        case TPP_PROD_VALIDATION_ERROR:
            return { ...state, loading: false, error: true, data: action.payload }
        case CLEAR_VALIDATION_TPP:
            return initialCreateTPPState
        default: return { ...state }
    }
}

export const CREATE_PRODUCTION_TPP = 'CREATE_PRODUCTION_TPP'

function createTPPReducer(state: ICreateProductionTPPState = initialCreateTPPState, action: Action): ICreateProductionTPPState {
    switch (action.type) {
        case `${CREATE_PRODUCTION_TPP}_PENDING`:
            return { ...state, loading: true, error: false, data: null };
        case `${CREATE_PRODUCTION_TPP}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${CREATE_PRODUCTION_TPP}_REJECTED`:
            return { ...state };
        case TPP_PROD_ERROR:
            return { ...state, loading: false, error: true, data: action.payload }
        case SIGNED_OUT_USER:
            return initialCreateTPPState;
        case FLUSH_STATE:
            return initialCreateTPPState
        default: return { ...state };
    }
}

export const GO_LIVE = 'GO_LIVE';

export const GO_LIVE_ERROR = 'GO_LIVE_ERROR';

export interface IGoLiveResponseState extends GenericState {
    data: IGoLiveResponse
}

const initialGoLiveResponseState: IGoLiveResponseState = {
    loading: false,
    error: false,
    data: null
}

function goLiveReducer(state: IGoLiveResponseState = initialGoLiveResponseState, action: Action): IGoLiveResponseState {
    switch (action.type) {
        case `${GO_LIVE}_PENDING`:
            return { ...state, loading: true, error: false };
        case `${GO_LIVE}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${GO_LIVE}_REJECTED`:
            return { ...state };
        case GO_LIVE_ERROR:
            return { ...state, error: true, data: action.payload }
        case SIGNED_OUT_USER:
            return initialGoLiveResponseState;
        case FLUSH_STATE:
            return initialGoLiveResponseState
        default: return { ...state };
    }
}

const initialProductsState: IProductsState = {
    loading: false,
    error: false,
    data: null
}

export const GET_PRODUCTS_PROD = 'GET_PRODUCTS_PROD'

function getProductsReducer(state = initialProductsState, action: Action): IProductsState {
    switch (action.type) {
        case `${GET_PRODUCTS_PROD}_PENDING`:
            return { ...state, loading: true, error: false };
        case `${GET_PRODUCTS_PROD}_FULFILLED`:
            return { ...state, loading: false, error: false, data: action.payload };
        case `${GET_PRODUCTS_PROD}_REJECTED`:
            return { ...state, loading: false, error: true };
        case SIGNED_OUT_USER:
            return initialProductsState
        default: return state;
    }
}
export interface ApiProductionState {
    selectedApplication: IApplicationState,
    updateApplicationResult: IApplicationState,
    userTPPs: ITPPState,
    updateTPPResult: ICreateProductionTPPState,
    selectedTPP: ISelectedTPPState,
    validateTPPResult: IValidateProdTPPSTate
    createTPPResult: ICreateProductionTPPState,
    goLiveResponse: IGoLiveResponseState,
    generateApiKeyState: IGenerateApiKeyState
    generateSecretState: IGenerateSecretState
    products: IProductsState
}

export const ApiProductionReducers: Reducer<ApiProductionState> = combineReducers({
    selectedApplication: getApplicationReducer,
    updateApplicationResult: updateApplicationReducer,
    userTPPs: getTPPReducer,
    updateTPPResult: updateTPPReducer,
    validateTPPResult: validateTPPReducer,
    selectedTPP: getSelectedTPPReducer,
    createTPPResult: createTPPReducer,
    goLiveResponse: goLiveReducer,
    generateApiKeyState: generateApiKeyReducer,
    generateSecretState: generateSecretReducer,
    products: getProductsReducer
})

export const reducers = {
    getApplicationReducer,
    getTPPReducer,
    createTPPReducer,
    goLiveReducer
}